<template>
  <el-row style="width: 100%; height: 100%">
    <el-table
      ref="tableRef"
      v-loading="loading"
      :data="tableData"
      stripe
      style="height: 100%"
      class="ones"
      @selection-change="handleSelectionChange"
    >
      <template #empty>
        <div class="empty">
          <img
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20250310/GGcwc8ZJ956UOoCE.png"
            alt=""
          />
          <p>暂无数据</p>
        </div>
      </template>
      <el-table-column
        v-if="checkbox === true || checkbox === 'true'"
        type="selection"
        label="selection"
        :selectable="selectEnable"
      />

      <!--单选 -->
      <el-table-column
        v-if="radio === true || radio === 'true'"
        type="radio"
        label=""
        width="32"
      >
        <template #default="scope">
          <el-radio
            v-model="radioValue"
            :label="scope.row"
            :disabled="selectedId === scope.row[selectField]"
            @change="handleSelectionChange"
          >
            {{ "" }}
          </el-radio>
        </template>
      </el-table-column>

      <!-- 防止表格table-column列顺序不对 -->
      <el-table-column width="1" />

      <template v-for="(field, index) in tableFields" :key="index">
        <el-table-column
          v-if="field.click !== undefined"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="scope">
            <el-button
              :key="field.text"
              type="text"
              size="small"
              @click="
                call(
                  field.click,
                  field.args_field !== undefined
                    ? scope.row[field.args_field]
                    : scope.row.id
                )
              "
            >
              {{ scope.row[field.text] }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="field.color === true"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="scope">
            <p v-if="scope.row[field.text] === '进行中'" class="green">
              {{ scope.row[field.text] }}
            </p>
            <p v-else>{{ scope.row[field.text] }}</p>
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="field.formatter"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="scope">
            <slot :name="field.text" :index="scope.$index" :row="scope.row" />
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="field.sort"
          :min-width="field.width"
          :prop="field.text"
          :align="field.align"
        >
          <template #dropdown>
            <div style="display: flex; align-items: center">
              <div>{{ field.label }}</div>
              <div style="margin-left: 10px">
                <div class="cursor" @click="handleASC(field.text, index)">
                  <i
                    class="el-icon-caret-top"
                    :class="field.asc ? 'sort' : ''"
                  />
                </div>
                <div
                  style="margin-top: -10px"
                  class="cursor"
                  @click="handleDESC(field.text)"
                >
                  <i class="el-icon-caret-bottom" />
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="field.special === true"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="scope">
            <slot name="op-special" :row="scope.row" :label="field.label" />
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="field.status === true"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="scope">
            <el-switch
              :model-value="!!scope.row[field.text]"
              class="ml-2"
              style="
                --el-switch-on-color: #57c860;
                --el-switch-off-color: #e9e9eb;
              "
              inline-prompt
              :loading="scope.row.loading"
              active-text="已启动"
              inactive-text="已禁用"
              width="65"
              :disabled="!$app.isShowBtn(field.btnName)"
              @change="popup($event, scope, field.text)"
            />
          </template>
          <!-- theRestFn(
                  field.disabled,
                  scope.row[field.disabled],
                  field.condition
                ) && -->
        </el-table-column>

        <el-table-column
          v-else
          :prop="field.text"
          :label="field.label"
          :min-width="field.width"
          :align="field.align"
        >
          <template #default="{ row }">
            <span :style="`width: ${field.width || '100%'} ;`" class="exceed_2">
              <template v-if="field.tooltip">
                <el-tooltip
                  effect="dark"
                  :content="row[field.text]"
                  placement="top"
                  :show-after="150"
                  popper-class="tooltip_width"
                >
                  {{ row[field.text] }}
                </el-tooltip>
              </template>
              <template v-else>
                {{ row[field.text] }}
              </template>
            </span>
          </template>
        </el-table-column>
      </template>

      <el-table-column
        v-if="opWidth || autoWidth"
        fixed="right"
        label="操作"
        align="center"
        :width="opWidth || autoWidth"
      >
        <template #default="scope">
          <div :class="operateClassName">
            <!-- 此处插槽只能存在一级 -->
            <slot name="op-right" :row="scope.row" :index="scope.$index">
            </slot>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--searchParams.type === 1不定位到页面底部-->
    <el-row
      v-if="total > 0"
      style="text-align: right; padding-top: 15px"
      :class="[
        condition.type === 1 ? 'margin-top' : '',
        paginationFixed ? 'navigation' : '',
      ]"
    >
      <el-pagination
        background
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :current-page="page"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="changeLimit"
        @current-change="changePage"
      />
    </el-row>
  </el-row>

  <v-dialog
    v-model:visible="isShowBox"
    width="25%"
    title="确认操作"
    @really="changeStatus"
  >
    <template #default>
      <el-row
        :style="{
          padding: '0 40px',
          'white-space': 'pre-wrap',
          'justify-content': statusCenter ? 'center' : 'left',
        }"
      >
        {{ deltitle }}
      </el-row>
    </template>
  </v-dialog>
</template>

<script setup lang="ts">
import {
  PropType,
  ref,
  onMounted,
  getCurrentInstance,
  nextTick,
  onUpdated,
} from "vue";
import instance from "@/api/request";
const props = defineProps({
  //列表查询请求地址
  url: {
    type: String,
    required: true,
  },
  //列表查询条件
  condition: {
    type: Object,
    default() {
      return {};
    },
  },
  //表格展示列
  tableFields: {
    type: Array as PropType<AnyType[]>,
    required: true,
    default() {
      return [];
    },
  },
  //多选或单选匹配的列表字段
  selectField: {
    type: String,
    default: "id",
  },
  //是否开启多选
  checkbox: {
    type: [String, Boolean],
    default: false,
  },
  //已选择的数据ID列表，前置条件：checkbox = true
  selectedIds: {
    type: Array,
    default() {
      return [];
    },
  },
  //是否开启单选
  radio: {
    type: [String, Boolean],
    default: false,
  },
  //已选择的数据ID，前置条件：radio = true
  selectedId: {
    type: [Number, String],
    default: 0,
  },
  //操作列宽度，为空则不显示操作列
  opWidth: {
    type: String,
    default: "",
  },
  //表格最大高度
  maxHeight: {
    type: String,
    default: "500",
  },
  //是否组件渲染后立即请求查询接口
  init: {
    type: [String, Boolean],
    default: true,
  },
  //列表查询请求方式，默认GET
  method: {
    type: String,
    default: "get",
  },
  dataApi: {
    type: Object,
    default: () => ({}),
  },
  host: {
    type: String,
    default: "shopping",
  },
  paginationFixed: {
    type: Boolean,
    default: true,
  },
  // 启动禁用url
  statusUrl: {
    type: String,
    default: "",
  },
  // 启动禁用请求方式，默认GET
  statusMethod: {
    type: String,
    default: "get",
  },
  statusCenter: {
    type: Boolean,
    default: true,
  },
  statusMessage: {
    type: Array,
    default: () => {
      return ["是否确认启用?", "是否确认禁用?"];
    },
  },
});

const emits = defineEmits<{
  (e: "call", row: object): void;
  (e: "handleSelectionChange", value: []): void;
  (e: "sort", row: SortType): void;
  (e: "handleGiveRes", row: any): void;
}>();

const loading = ref(false); // 表格加载
const total = ref(0); //总数量
const page = ref(1); // 当前页
const limit = ref(10); //每页查询数
const tableData = ref([]); //表格数据
const radioValue = ref(""); //单选时选中的值

const app = getCurrentInstance()?.proxy;

const operateClassName = ref();

onMounted(() => {
  operateClassName.value = `optionDiv${new Date().getTime()}`;
  if (props.init === true || props.init === "true") {
    search();
  }
  initOptionWidth();
});

const call = (op: string, row: string) => {
  const dt = {
    op,
    row,
  };
  emits("call", dt);
};

//检查多选是否禁用
const selectEnable = (row: { [name: string]: any }) => {
  if (props.selectedIds.length > 0) {
    if (row[props.selectField]) {
      const value = row[props.selectField];
      if (props.selectedIds.includes(value)) {
        return false;
      }
    }
  }
  return true;
};

// 重置
const reset = () => {
  page.value = 1;
  search();
};

//列表查询
const search = () => {
  nextTick(() => {
    if (!props.url) return;
    if (props.radio === true || props.radio === "true") {
      radioValue.value = "";
    }

    loading.value = true;
    const data = {
      ...props.condition,
      page: page.value,
      limit: limit.value,
    };
    instance[props.method](
      props.url,
      props.method === "get" ? { params: data } : data
    )
      .then((response: any) => {
        loading.value = false;
        if (response.code == 200) {
          tableData.value = response.data.list;
          total.value = response.data?.count;
          //需要给父组件传递数据时候
          emits("handleGiveRes", response);
        } else {
          tableData.value = [];
          total.value = 0;
          app?.$message.error(response.message);
        }
        initOptionWidth();
      })
      .catch(() => {
        loading.value = false;
      });
  });
};

//切换显示数量
const changeLimit = (myLimit: number) => {
  limit.value = myLimit;
  search();
  return false;
};

//切换分页
const changePage = (myPage: number) => {
  page.value = myPage;
  search();
  return false;
};

const handleSelectionChange = (value: []) => {
  emits("handleSelectionChange", value);
};

const handleASC = (name: string, index: string | number) => {
  const dt = {
    type: "ASC",
    name,
    index,
  };
  emits("sort", dt);
};

const handleDESC = (name: string) => {
  const dt = {
    type: "DESC",
    name,
  };
  emits("sort", dt);
};

const isShowBox = ref(false);
const deltitle = ref();
const scopeVal = ref();
const type = ref();
const tableName = ref();

const popup = (val: boolean, scope: any, name: string) => {
  isShowBox.value = true;
  scopeVal.value = scope;
  tableName.value = name;
  type.value = val;
  deltitle.value = val ? props.statusMessage[0] : props.statusMessage[1];
};

const changeStatus = () => {
  isShowBox.value = false;
  const rowData: any = tableData.value[scopeVal.value.$index];

  rowData.loading = true;
  const dt = {
    id: scopeVal.value.row.id,
    status: type.value ? 1 : 0,
  };
  instance[props.statusMethod](props.statusUrl, dt)
    .then((response: any) => {
      if (response.code == 200) {
        rowData[tableName.value] = type.value;
        app?.$message.success("修改状态成功");
      } else {
        app?.$message.error(response.message);
      }
      rowData.loading = false;
    })
    .catch(() => {
      rowData.loading = false;
    });
};

// ----------------- 操作栏宽度动态计算 -----------------
const tableRef = ref();
const autoWidth = ref(1);
// 表头部重新渲染
onUpdated(() => {
  initOptionWidth();
});
const initOptionWidth = () => {
  if (props.opWidth) return;
  nextTick(() => {
    const opts = document.getElementsByClassName(`${operateClassName.value}`);
    console.log(opts, "optsoptsoptsopts");

    [...opts].map((item) => {
      let w = 0;
      [...item.children].map((child) => {
        w += child.offsetWidth + 30;
      });
      autoWidth.value = autoWidth.value > w ? autoWidth.value : w;
    });
    if (autoWidth.value > 1) {
      autoWidth.value = autoWidth.value > 200 ? autoWidth.value : 200;
    }
    console.log(autoWidth.value, "autoWidthautoWidthautoWidth");

    tableRef.value?.doLayout();
  });
};

defineExpose({
  tableData,
  search,
  reset,
});
</script>

<style scoped lang="scss">
.cursor {
  cursor: pointer;
}

.sort {
  color: skyblue;
}

.empty {
  padding-top: 80px;
}

:deep(.el-pagination) {
  justify-content: flex-end;
}
.navigation {
  width: calc(100vw - 102px);
  position: fixed;
  bottom: 0;
  right: 8px;
  box-sizing: border-box;
  background: #fff;
  justify-content: flex-end;
  z-index: 999;
  padding: 5px 15px;
}
:deep(.el-table tr) {
  height: 60px;
}

:deep(.el-table .cell) {
  text-overflow: clip;
}

:deep(.el-switch.is-checked .el-switch__core .el-switch__action) {
  box-shadow: -1px 0 3px 0 #989696;
}

:deep(.el-switch__core .el-switch__inner .is-text) {
  color: #848587;
}
:deep(.is-checked .el-switch__core .el-switch__inner .is-text) {
  color: #fff;
}

:deep(.el-table th.el-table__cell.is-leaf) {
  background: $--color-table-thead-th-bg;
}
</style>
<style>
.tooltip_width {
  max-width: 200px !important;
}
</style>
